import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';

import { Button, Paragraph, Subheading } from '@treams/treams-ui';
import { SelectConversationTypeModal } from './components';
import { EvaluationFormFragment } from 'generated/graphql';

type Props = {
	forms: EvaluationFormFragment[];
	onChange: (evaluationFormId: string) => void;
};

export const SelectConversationType = ({ forms, onChange }: Props) => {
	const [modalVisbility, setModalVisibility] = useState(false);
	const [selectedForm, setSelectedForm] = useState<EvaluationFormFragment | undefined>();

	const { t } = useTranslation('', {
		keyPrefix: 'evaluations.create.modal.form.selectConversationType',
	});
	const { localize } = useLocalize();

	const selectedFormName = selectedForm ? localize(selectedForm.title).text : t('noSelection');

	const toggleModalVisibility = () => {
		setModalVisibility(!modalVisbility);
	};

	if (selectedForm) {
		onChange(selectedForm.id);
	}

	return (
		<StyledBox p={2} mb={3}>
			<Box display="flex" flexDirection="row" alignItems="center">
				<Flex flexGrow={1} pl={2}>
					<Paragraph>{selectedFormName}</Paragraph>
				</Flex>

				<Button
					type="card"
					title={<Subheading>{t('selection.title')}</Subheading>}
					onClick={toggleModalVisibility}
				/>
			</Box>
			<SelectConversationTypeModal
				selected={selectedForm}
				visible={modalVisbility}
				onClose={toggleModalVisibility}
				onSave={setSelectedForm}
				forms={forms}
			/>
		</StyledBox>
	);
};

const StyledBox = styled(Box)`
	background-color: white;
	border-radius: 5px;
`;
